import { SvgIcon, SvgIconProps } from '@mui/material'

const SyncErrorIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon role="img" viewBox="0 0 18 18" fill="none" {...props}>
      <path
        d="M3.02304 15.5243H6.01012C6.12621 15.5268 6.24044 15.4932 6.33644 15.429C6.38766 15.3946 6.43369 15.3516 6.47204 15.3007C6.52931 15.2249 6.56785 15.1342 6.58077 15.0354C6.58468 15.0058 6.58618 14.9761 6.58536 14.9467V12.4191C6.58536 12.1084 6.33352 11.8566 6.02286 11.8566C5.7122 11.8566 5.46036 12.1084 5.46036 12.4191V13.9759C3.86905 12.8642 2.83545 11.0517 2.83545 8.96509C2.83545 6.5365 4.23454 4.43364 6.27328 3.42048C6.55148 3.28223 6.66493 2.94462 6.52668 2.66642C6.38842 2.38822 6.05082 2.27477 5.77262 2.41302C3.36618 3.60892 1.71045 6.09313 1.71045 8.96509C1.71045 11.1493 2.66744 13.0758 4.17941 14.3993H3.02304C2.71238 14.3993 2.46054 14.6511 2.46054 14.9618C2.46054 15.2724 2.71238 15.5243 3.02304 15.5243Z"
        fill="currentColor"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5184 15.3342C11.3801 15.056 11.4936 14.7184 11.7718 14.5801C13.8105 13.567 15.2096 11.4641 15.2096 9.03549C15.2096 6.61178 13.8151 4.55797 11.7718 3.54255C11.4936 3.4043 11.3801 3.06669 11.5184 2.78849C11.6566 2.51029 11.9942 2.39684 12.2724 2.5351C14.6743 3.72873 16.3346 6.15864 16.3346 9.03549C16.3346 11.9075 14.6789 14.3917 12.2724 15.5876C11.9942 15.7258 11.6566 15.6124 11.5184 15.3342Z"
        fill="currentColor"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4596 3.03882C11.4596 2.72816 11.7114 2.47632 12.0221 2.47632H15.0221C15.3328 2.47632 15.5846 2.72816 15.5846 3.03882C15.5846 3.34948 15.3328 3.60132 15.0221 3.60132H12.0221C11.7114 3.60132 11.4596 3.34948 11.4596 3.03882Z"
        fill="currentColor"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0221 6.14394C11.7114 6.14394 11.4596 5.8921 11.4596 5.58144V3.03882C11.4596 2.72816 11.7114 2.47632 12.0221 2.47632C12.3328 2.47632 12.5846 2.7282 12.5846 3.03886V5.58144C12.5846 5.8921 12.3328 6.14394 12.0221 6.14394Z"
        fill="currentColor"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.56255 4.5C9.56255 4.18934 9.31071 3.9375 9.00005 3.9375C8.68939 3.9375 8.43755 4.18934 8.43755 4.5V10.5C8.43755 10.8107 8.68939 11.0625 9.00005 11.0625C9.31071 11.0625 9.56255 10.8107 9.56255 10.5V4.5ZM9.9375 12.9376C9.9375 13.4554 9.51776 13.8751 9 13.8751C8.48224 13.8751 8.0625 13.4554 8.0625 12.9376C8.0625 12.4198 8.48224 12.0001 9 12.0001C9.51776 12.0001 9.9375 12.4198 9.9375 12.9376Z"
        fill="currentColor"
      ></path>
    </SvgIcon>
  )
}

export default SyncErrorIcon
